
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.53 14.13c-2.1-.76-2.77-1.41-2.77-2.79 0-.83.64-.56.92-2.08.12-.63.68 0 .79-1.45a.73.73 0 00-.31-.72s.16-.85.22-1.5c.08-.81-.47-2.91-3.38-2.91s-3.46 2.1-3.38 2.91c.06.65.22 1.5.22 1.5a.73.73 0 00-.31.72c.11 1.44.67.82.79 1.45.28 1.52.92 1.25.92 2.08 0 1.38-.67 2-2.77 2.79S2 15.67 2 16.21V18h16v-1.79c0-.54-1.37-1.32-3.47-2.08z"}})])
          )
        }
      }
    